import React from 'react';
import { Typography } from '@mui/material';
import styled from 'styled-components';
import moment from 'moment';

/**
 * SummarizeExampleCard component
 * Displays a single summarize example card
 * @param {Object} example - The summarize example object with properties:
 *   - _id: string
 *   - candidateName: string
 *   - issue: string
 *   - text: string
 *   - sources: Array of source objects with directQuote field
 *   - createdAt: Date string
 */
const SummarizeExampleCard = ({ example }) => {
  if (!example) return null;

  // Get all direct quotes from sources
  const directQuotes = example.sources
    ?.filter(source => source.directQuote)
    .map(source => source.directQuote) || [];

  return (
    <ExampleCard>
      <HeaderRow>
        <Typography variant='body2' style={{ fontSize: '11px', fontWeight: 500, color: '#888' }}>
          {example.candidateName} on {example.issue}
        </Typography>
        {example.createdAt && (
          <Typography variant='body2' style={{ fontSize: '10px', color: '#999' }}>
            {moment(example.createdAt).format('MMM D, YYYY')}
          </Typography>
        )}
      </HeaderRow>
      
      {/* The summary text in the highlighted box */}
      <SummarySection>
        <SummaryText>
          {example.text}
        </SummaryText>
      </SummarySection>
      
      {/* Show direct quotes that produced this summary */}
      {directQuotes.length > 0 && (
        <QuotesSection>
          {directQuotes.map((quote, idx) => (
            <QuoteText key={idx}>
              "{quote}"
            </QuoteText>
          ))}
        </QuotesSection>
      )}
    </ExampleCard>
  );
};

const ExampleCard = styled.div`
  padding: 10px;
  background-color: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #E0E0E0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

const SummarySection = styled.div`
  padding: 8px;
  background-color: #F9F9F9;
  border-left: 3px solid #E0E0E0;
  border-radius: 2px;
`;

const SummaryText = styled(Typography)`
  font-size: 13px !important;
  font-family: 'Lato' !important;
  font-weight: 400 !important;
  color: #333 !important;
  line-height: 1.5 !important;
`;

const QuotesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const QuoteText = styled(Typography)`
  font-size: 11px !important;
  font-family: 'Lato' !important;
  font-weight: 400 !important;
  font-style: italic !important;
  color: #666 !important;
  line-height: 1.4 !important;
`;

export { SummarizeExampleCard };

